/* src/app/shared/components/alerts-handler/alerts-handler.component.scss */
.always-on-top {
  position: fixed;
  right: 20px;
  z-index: 1000;
  bottom: 110px;
}
/*# sourceMappingURL=alerts-handler.component.css.map */
